__turbopack_context__.v({
  "checkbox": "Checkbox-module__QePIQa__checkbox",
  "error": "Checkbox-module__QePIQa__error",
  "errorText": "Checkbox-module__QePIQa__errorText",
  "helpText": "Checkbox-module__QePIQa__helpText",
  "icon": "Checkbox-module__QePIQa__icon",
  "input": "Checkbox-module__QePIQa__input",
  "label": "Checkbox-module__QePIQa__label",
  "labelDisabled": "Checkbox-module__QePIQa__labelDisabled",
});
